import { LinkCreationService } from '@sportal365/smp-widget-utils';

// Constants
import { TARGET_BLANK, TARGET_SELF } from '../../../constants/windowTarget';
import { assetsPlaceholder } from '../../../constants/assetsPlaceholder';

// Types
import { COMPETITION_ENTITY } from '../../../constants/entityTypes';
import { IStandingsCompetitionResponse, IStandingsConfig } from '../../../types/standings';

interface INormalizeStandingsCompetition {
  competition?: IStandingsCompetitionResponse;
  dataEntityLinks?: IStandingsConfig['dataEntityLinks'];
}

const getCompetitionLogo = (competition?: IStandingsCompetitionResponse) => {
  if (competition?.assets?.logo?.url) return competition?.assets?.logo?.url;

  return competition?.country?.assets.flag?.url ?? assetsPlaceholder.competition;
};

export const normalizeStandingsCompetitionResponseData = ({ competition, dataEntityLinks }: INormalizeStandingsCompetition) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  return {
    id: competition?.id ?? '',
    title: competition?.name ?? '',
    subTitle: competition?.country?.name ?? '',
    logo: getCompetitionLogo(competition),
    url:
      linkService?.createEntityUrl(competition?.id ?? '', competition?.entity_type || COMPETITION_ENTITY, '', competition?.slug ?? '') ??
      '#',
    urlTarget: target,
  };
};
